<template>
    <Head title="Votação" />
    <AuthenticatedLayout>
        <Heading title="Votação" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div v-if="!isComputer" class="h-[60vh] flex justify-center items-center p-4">
            <h1 class="text-primary font-bold text-2xl">Utilize um computador para acessar votação de fotos.</h1>
        </div>
        <div
            v-else
            class="bg-gray-100 px-6 py-8 flex items-start gap-x-8"
        >
            <FilterContest
                :campaigns="contests"
                :regions="computedRegions"
                @updateFilter="sendFilter($event)"
            />
            <section class="sm:pt-2 flex flex-col w-full">
                <div class="flex items-center text-primary text-xs hover:underline cursor-pointer invisible">
                    <Icon name="SetaEsquerda" class="w-4"/>
                    <a>Voltar</a>
                </div>
                <h1 class="text-primary font-bold text-sm">Página Inicial</h1>
                <h2 class="text-primary font-bold mt-4">Votação de fotos</h2>
                <p>Para iniciar a votação, filtre a campanha, verifique se o seu nível está disponível e clique no botão "<span class="font-bold">Começar Votação</span>"</p>
                <div v-if="isLoadingContests" class="w-full min-h-[30vh] flex justify-center items-center">
                    <Spinner />
                </div>
                <div v-else class="w-full mt-8">
                    <div>
                        <div class="bg-white rounded-2xl border-gray-400 border pb-4 px-4 sm:px-1 break-all">
                            <div class="flex flex-col">
                                <section>
                                    <div class="text-black pt-2 font-bold xl:px-4 grid grid-cols-list border-b border-gray-400">
                                        <p class="pb-2 border-r border-gray-400 flex flex-wrap justify-center items-center gap-x-2">
                                            Campanha
                                        </p>
                                        <p class="pb-2 text-center border-r border-gray-400 flex items-center justify-center gap-x-2">Nível</p>
                                        <p class="pb-2 text-center border-r border-gray-400 flex items-center justify-center gap-x-2">% de Conclusão</p>
                                        <p class="pb-2 text-center border-r border-gray-400 flex items-center justify-center gap-x-2">Status</p>
                                        <p class="pb-2 text-center flex items-center justify-center gap-x-2">Iniciar Votação</p>
                                    </div>
                                    <div
                                    v-for="item in filteredContests"
                                    :key="rowKey(item)"
                                    class="rounded-xl xl:px-4 grid grid-cols-list grid-cols-ranking-participants"
                                    >

                                    <!-- Campanha -->
                                    <p class="border-r border-gray-400 flex items-center justify-enter px-1">
                                        {{ handleContestName(item) }}
                                    </p>

                                    <!-- NÍVEIS -->
                                    <ul
                                    class="border-r border-gray-400 flex flex-col items-center gap-y-1 justify-center px-1 py-2"
                                    :key="'levels-'+item.id+'-'+getStagesByContest(item).length"
                                    >
                                    <li
                                        v-for="stage in getStagesByContest(item)"
                                        :key="stage"
                                        class="group p-2 rounded relative text-sm"
                                        :class="handleBgColorStatus(item, stage)"
                                    >
                                        <div class="text-white text-[10px] leading-none absolute top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2">
                                        {{ getVisibleStage(stage, item) }}
                                        </div>

                                        <!-- popover -->
                                        <div class="group-hover:flex group-hover:z-10 hidden flex-col gap-y-4 px-1 pt-2 pb-1 whitespace-nowrap absolute bg-white border border-gray-500">
                                        <div>
                                            <h1 class="text-primary">Status:</h1>
                                            <p class="font-bold text-black">{{ handleStatusStageVoting(item, stage) }}</p>
                                        </div>

                                        <div v-if="getContestRegionStageCompleteByStage(item.regionalStages, stage, item).length">
                                            <h1 class="text-primary">{{ stage == 1 ? 'Sub-regionais' : 'Regionais' }} Concluídas:</h1>
                                            <ul>
                                            <li
                                                v-for="region in getContestRegionStageCompleteByStage(item.regionalStages, stage, item)"
                                                :key="'done-'+item.id+'-'+stage+'-'+region"
                                            >
                                                {{ region }}
                                            </li>
                                            </ul>
                                        </div>

                                        <div v-if="getContestRegionStagePendingByStage(item.regionalStages, stage, item).length">
                                            <h1 class="text-primary">Faltam Concluir:</h1>
                                            <ul>
                                            <li
                                                v-for="region in getContestRegionStagePendingByStage(item.regionalStages, stage, item)"
                                                :key="'todo-'+item.id+'-'+stage+'-'+region"
                                            >
                                                {{ region }}
                                            </li>
                                            </ul>
                                        </div>
                                        </div>
                                    </li>
                                    </ul>
                                    <!-- % DE CONCLUSÃO -->
                                    <ul
                                    v-if="!isLoadingContestCompletionPercentages"
                                    class="border-r border-gray-400 flex flex-col items-center justify-center px-1 py-2"
                                    >
                                    <li
                                        v-for="percentualStage in getPercentualStagesByContestId(item.id)"
                                        :key="'pct-'+item.id+'-'+percentualStage"
                                    >
                                        {{ percentualStage ? percentualStage + '%' : '' }}
                                    </li>
                                    </ul>

                                    <ul
                                    v-else
                                    class="border-r border-gray-400 flex flex-col items-center justify-center px-1 py-2"
                                    >
                                    <Spinner />
                                    </ul>
                                    <ul class="border-r border-gray-400 flex flex-col items-center justify-center px-1 py-2 text-center">
                                        <li v-for="stage in getStagesByContest(item)" :key="stage">{{handleStatusStageVoting(item, stage)}}</li>
                                    </ul>
                                    <!-- Ação -->
                                    <div class="flex justify-center items-center">
                                        <Button
                                        v-if="isAvailableToViewHistory(item)"
                                        @click="goToHistoric(item)"
                                        class="max-w-[180px] !p-2 !text-base rounded-2xl bg-primary !text-white hover:bg-blue-400 hover:border-blue-400 disabled:bg-gray-400 disabled:border-gray-400 disabled:pointer-events-none"
                                        >
                                        Ver Histórico
                                        </Button>
                                        <Button
                                        v-else
                                        :disabled="!this.hasPendingVoting(item)"
                                        @click="startVoting(item)"
                                        class="max-w-[180px] !p-2 !text-base rounded-2xl bg-primary !text-white hover:bg-blue-400 hover:border-blue-400 disabled:bg-gray-400 disabled:border-gray-400 disabled:pointer-events-none"
                                        >
                                        Começar a Votação
                                        </Button>
                                    </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </AuthenticatedLayout>
    <transition v-if="error">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4"
                >
                    <button class="float-right" @click="error = ''">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Erro
                    </h1>
                    <p class="mt-2.5">
                        {{error}}
                    </p>
                </div>
            </div>
        </transition>
        <StatusRegion
        :showModal="showRegionsStatusModal"
        :currentRegionalStatus="contestRegionalStatus"
        :currentAvailableRegions="contestAvailableRegions"
        @closeModal="showRegionsStatusModal = false"
    />
</template>
<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Input from "@/Components/UI/Form/Select.vue";
import FilterContest from "@/Components/PhotosVoting/FilterContest.vue";
import PhotosByParticipantTable from "@/Components/Performance/Team/PhotosByParticipantTable.vue";
import Button from "@/Components/Button.vue";
import StatusRegion from "@/Components/PhotosVoting/Modals/StatusRegion.vue";
import Spinner from "@/Components/UI/Loaders/Spinner.vue";
import download from "downloadjs";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Icon,
        Input,
        FilterContest,
        PhotosByParticipantTable,
        Button,
        StatusRegion,
        Spinner,
    },
    props: {
        contests: Object,
        contestCanVoteByParticipant: Object,
        regions: Object,
    },
    data() {
        return {
            contestRegionalStatus: [],
            showRegionsStatusModal: false,
            loadedContests: this.contests,
            error: "",
            isLoadingContestCompletionPercentages: false,
            isLoadingContests: false,
            contestCompletionPercentages: [],
        };
    },
    mounted() {
        this.fetchContestsCompletionPercentages();
    },
    methods: {
        handleContestName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        handleContestVotingStatusMessage(contest) {
            switch (contest?.votingStatus) {
                case "E":
                    return "Em Andamento";
                    break;
                case "C":
                    return "Concluído";
                    break;
                default:
                    return "Não Iniciado";
                    break;
            }
        },
        async showRegionsStatus(item) {
            this.contestRegionalStatus = [];
            const { data: result } = await axios.get(
                route("contest.get-regional-stage", item.id)
            );

            this.contestRegionalStatus =
                result.finishedRegionalStages.regionalStages || [];
            this.contestAvailableRegions = result.availableRegions || [];
            this.showRegionsStatusModal = true;
        },
        startVoting(contest) {
            this.error = "";
            const contestId = contest.id;

            if(!this.hasPendingVoting(contest)) {
                this.error = "Sem pendências de votação para essa campanha!"
                return;
            }

            this.$inertia.get(route("photo.voting-show", {contestId}));
        },
        sendFilter(dataFilter) {
            this.isLoadingContests = true;

            axios
                .post(route("photo.voting-filter.contests"), dataFilter)
                .then((response) => {

                    this.loadedContests = response.data.data;
                    this.isLoadingContests = false;
                    this.fetchContestsCompletionPercentages();
                }).catch(error => {
                    console.log(error);
                    this.isLoadingContests = false;
                });

        },
        getContestRegionStageCompleteByStage(regionalStages, currentStage, contest) {
        const regs = regionalStages || [];
        return regs.reduce((acc, curr) => {
            const name    = curr.region?.name ?? curr.regionName ?? curr.region_id;
            const stage   = Number(curr.stage);
            const flagS   = String(curr.merchanC || 'N').toUpperCase() === 'S';

            // Nível 2: concluída se (stage > 2) ou (stage == 2 e flag S)
            if (currentStage === 2) {
            if (stage > 2 || (stage === 2 && flagS)) acc.push(name);
            return acc;
            }

            // Nível 3: concluída se (stage >= 3) ou (stage == 2 e flag S)
            if (currentStage === 3) {
            if (stage >= 3 ) acc.push(name);
            return acc;
            }

            // Níveis 4/5: usa o mapa efetivo (4→3, 5→4) e considera concluído se (stage > eff)
            const eff = this.effectiveDbStage(currentStage, contest);
            if (stage > eff) acc.push(name);
            return acc;
        }, []);
        },
        getContestRegionStagePendingByStage(regionalStages, currentStage, contest) {
        const regs = regionalStages || [];
        return regs.reduce((acc, curr) => {
            const name    = curr.region?.name ?? curr.regionName ?? curr.region_id;
            const stage   = Number(curr.stage);
            const flagS   = String(curr.merchanC || 'N').toUpperCase() === 'S';

            // Nível 2: pendente apenas se (stage <= 2) e flag N
            if (currentStage === 2) {
            if (stage <= 2 && !flagS) acc.push(name);
            return acc;
            }

            // Nível 3: pendente se (stage < 3) e NÃO é (stage == 2 e flag S)
        if (currentStage === 3) {
        if (stage < 3) acc.push(name);
        return acc;
        }

            // Níveis 4/5: pendente se (stage <= eff)
            const eff = this.effectiveDbStage(currentStage, contest);
            if (stage <= eff) acc.push(name);
            return acc;
        }, []);
        },
        getStagesByContest(contest) {
        let stages = [1, 2, 3];

        // se o dado já chegou em 4, mostra 4 (mesmo que winningType não seja 'R')
        const force4 = this.hasStage4OrMore(contest);
        const isRegional = contest.winningType === 'R' || force4;
        if (isRegional) stages.push(4);

        // nacional com pódio → 5 níveis
        const isNational = (contest.podiumType === 'N' || contest.winningType === 'N');
        if (isNational) stages.push(5);

        return stages;
        },
        handleBgColorStatus(contest, stage) {
        const regs = contest.regionalStages || [];
        if (!regs.length) return 'bg-error';

        if (stage === 2) {
        const total = regs.length;
        const done  = regs.filter(r => String(r.merchanC || 'N').toUpperCase() === 'S').length;

        if (done === total && total > 0) return 'bg-success'; // verde só quando 100%
        return 'bg-yellow'; // 0% ou parcial = amarelo
        }

        if (stage === 3) {
        const total = regs.length;
        const done  = regs.filter(r => Number(r.stage) >= 3).length;

        if (done <= 0) {
            return 'bg-error';   // cinza
        }

        if (done === total) {
            return 'bg-success'; // verde
        }

        // se tem stage 2 com flag S → continua amarelo
        return 'bg-yellow';
        }

        const eff = this.effectiveDbStage(stage, contest);
        if (regs.some(el => Number(el.stage) === eff)) return 'bg-yellow';
        if (regs.every(el => Number(el.stage) > eff))  return 'bg-success';
        if (regs.some(el => Number(el.stage) > eff))   return 'bg-yellow';
        return 'bg-error';
        },

        handleStatusStageVoting(contest, stage) {
        const regs = contest.regionalStages || [];
        if (!regs.length) return 'Não Iniciada';

        if (stage === 2) {
        const total = regs.length;
        const done  = regs.filter(r => String(r.merchanC || 'N').toUpperCase() === 'S').length;

        if (done === total && total > 0) return 'Concluída'; // verde
        return 'Em andamento';                               // 0% ou parcial → amarelo
        }


        if (stage === 3) {
        const total = regs.length;

        // concluídos = só quem realmente está no stage >= 3
        const done = regs.filter(r => Number(r.stage) >= 3).length;

        if (done <= 0) {
            return 'Não Iniciada';
        }

        // só se 100% chegaram no 3+ é que fica concluído
        if (done === total) {
            return 'Concluída';
        }

        // se existe qualquer um no stage 2 com flag S → mantém "Em andamento"
        const anyStage2FlagS = regs.some(
            r => Number(r.stage) === 2 && String(r.merchanC || 'N').toUpperCase() === 'S'
        );
        if (anyStage2FlagS) {
            return 'Em andamento';
        }

        return 'Em andamento'; // default para parcial
        }

        const eff = this.effectiveDbStage(stage, contest);
        if (regs.some(el => Number(el.stage) === eff)) return 'Em andamento';
        if (regs.every(el => Number(el.stage) > eff))  return 'Concluída';
        if (regs.some(el => Number(el.stage) > eff))   return 'Em andamento';
        return 'Não Iniciada';
        },
        handleStatusIcon(contest, stage) {
            if(!contest.regionalStages.length) {
                return 'Exclamation';
            }

            if(contest.regionalStages.some(el => el.stage == stage)) {
                return 'Exclamation';
            }

            if(contest.regionalStages.every(el => el.stage > stage)) {
                return 'CheckMark'
            }

            if(contest.regionalStages.some(el => el.stage > stage)) {
                return 'Exclamation';
            }

            return 'Exclamation';
        },
        hasPendingVoting(contest) {
            return this.computedContestCanVoteByParticipant.some(el => el.id === contest.id);
        },
        getPercentualStagesByContest(contest) {
        const found = this.computedContestCompletionPercentages.find(el => el.contestId === contest.id);
        const base  = found?.percentualStages || [];

        const toNum = v => (v === '' || v === null || v === undefined ? '' : Number(v));
        const p1 = toNum(base[0]);
        /* p2 do backend não é usado no UI lvl 2 (porque agora lvl 2 é merchanC) */
        const p3 = toNum(base[2]); // nacional / estágio 3 no backend
        const p4 = toNum(base[3]); // pódio / estágio 4 no backend

        // Nível 2 via merchanC
        const regs = contest.regionalStages || [];
        const totalRegs = regs.length;
        const doneRegs  = regs.filter(r => String(r.merchanC || 'N').toUpperCase() === 'S').length;
        const v2 = totalRegs ? Math.round((doneRegs / totalRegs) * 100) : '';

        const visible    = this.getStagesByContest(contest); // [1,2,3,4] ou [1,2,3,4,5]
        const isNational = visible.length === 5;
        const opened4    = this.hasStage4OrMore(contest);

        let out;
        if (!isNational) {
            // 4 níveis: 3 usa p3; 4 usa p4 (ou p3 se p4 vazio)
            const v4 = (p4 === '' || p4 === 0) ? p3 : p4;
            out = [p1, v2, p3, v4];
        } else {
            // 5 níveis: 3/4 espelham p3 (antes de abrir 4); quando 4 abrir, 3 fica vazio e 4 mostra p3
            out = opened4 ? [p1, v2, '', p3, p4] : [p1, v2, p3, p3, p4];
        }

        if (out.length < visible.length) out = out.concat(Array(visible.length - out.length).fill(''));
        if (out.length > visible.length) out = out.slice(0, visible.length);

        return out.map(v => (v === '' ? '' : String(v)));
        },


        toNum(v) {
        if (v === '' || v === undefined || v === null) return 0;
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
        },
        isAvailableToViewHistory(contest) {
            const contestJudges = this.$page.props.auth.user.contestJudges;
            const hasContestJudge = contestJudges.some(el => el.contestId == contest.id);
            const isModerator = Boolean(this.$page.props.auth.user.isModerator?.data?.[0]);

            return !this.hasPendingVoting(contest) && contest.votingStatus != "N" && (hasContestJudge || isModerator);
        },
        goToHistoric(contest) {
            this.$inertia.get(route('photo-voting.historic', {contestId: contest.id}));
        },
        downloadContestWinnersPDF(file) {
          axios
            .get(
              route(
                'download.file',
                {
                  fileId: file.id,
                  fileName: file.filename
                }
              ),
            {
              responseType: 'blob',
            })
            .then((response) => {
              const content = response.headers['content-type'];
              let filename = "";
              const disposition = response.headers['content-disposition'];

              if (disposition && disposition.indexOf('attachment') !== -1) {
                  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                  const matches = filenameRegex.exec(disposition);
                  if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                  }
              }

              download(
                response.data,
                filename,
                content,
              );
            })
            .catch((error) => console.log(error));
        },
        fetchContestsCompletionPercentages() {
            this.isLoadingContestCompletionPercentages = true;

            axios
                .get(route('photo-voting.get-contest-completion-percentages'), {params: {
                    contestIds: this.filteredContests.map(el => el.id)
                }})
                .then(response => {
                    const responseData = response.data;

                    if(responseData.statusCode === 200) {
                        this.contestCompletionPercentages = responseData.data;
                    }
                })
                .catch((error) => console.log(error))
                .finally(() => {
                    this.isLoadingContestCompletionPercentages = false;
                });
        },
        getVisibleStage(stage, contest) {
        return stage;
        },
        isFakeStage3(contest) {
        const regs = contest?.regionalStages || [];
        const anyAtOrBeyond3 = regs.some(el => Number(el.stage) >= 3);
        const anyStage2FlagS  = regs.some(el => Number(el.stage) === 2 && String(el.merchanC || 'N').toUpperCase() === 'S');
        return anyStage2FlagS && !anyAtOrBeyond3;
        },// existe alguma regional em stage 2 com a flag S?
        hasStage2FlagS(contest) {
        return (contest?.regionalStages || []).some(
            el => Number(el.stage) === 2 && String(el.merchanC || 'N').toUpperCase() === 'S'
        );
        },

        // já temos alguém no stage 4+?
        hasStage4OrMore(contest) {
        return (contest?.regionalStages || []).some(el => Number(el.stage) >= 4);
        },

        // último nível visível no front (4 para regional, 5 para nacional)
        lastVisibleStage(contest) {
        const stages = this.getStagesByContest(contest);
        return stages[stages.length - 1];
        },
        // ===== MAPA DE ESTÁGIOS (mantido, sem "fake 3") =====
        effectiveDbStage(stage, contest) {
        if (stage === 4) return 3;
        if (stage === 5) return 4;

        // 🔑 tratamento especial:
        // se estamos olhando para o nível 3 visível
        // e alguma região está no stage 2 com merchanC = 'S',
        // considera que já equivale ao estágio 3 real.
        if (stage === 3) {
            const regs = contest?.regionalStages || [];
            const anyFlagS = regs.some(
            el => Number(el.stage) === 2 && String(el.merchanC || 'N').toUpperCase() === 'S'
            );
            if (anyFlagS) return 2; // força comparação contra stage=2 + merchanC
        }

        return stage;
        },
        rowKey(item) {
        return `${item.id}-${this.getStagesByContest(item).length}-${this.getPercentualStagesByContest(item).length}`;
        },
        getPercentualStagesByContestId(contestId) {
        const findPercentualStages = this.computedContestCompletionPercentages.find(
            el => el.contestId === contestId
        );
        return findPercentualStages?.percentualStages;
        }
    },
    computed: {
        filteredContests() {
            return this.loadedContests
                .filter((el) => {
                    const name = el.name?.toLowerCase() ?? "";
                    return name != "nespoints" && !name.includes("desafio nescafé week");
                })
                .sort((a, b) => {
                    if (a.name === b.name)
                        return b.startDate < a.startDate ? 1 : -1;
                    return a.name.localeCompare(b.name);
                });
        },
        computedRegions() {
            return this.regions.map(({id, name}) => {
                return {
                    value: id,
                    name
                }
            });
        },
        computedContestCanVoteByParticipant() {
            const campaignsFiltered = this.contestCanVoteByParticipant
                .sort((a, b) => {
                    if (a.name === b.name)
                        return moment(b.startDate).isBefore(moment(a.startDate))
                            ? 1
                            : -1;

                    return a.name.localeCompare(b.name);
                })
                .filter((campaign) => {
                    return campaign.votingStatus != "C"
                });

            return campaignsFiltered.map((contest) => ({
                name: contest.name,
                id: contest?.id,
            }));
        },
        isComputer() {
            if (navigator.userAgentData != undefined && !navigator.userAgentData.mobile) {
                return true;
            }
        },
        computedContestCompletionPercentages() {
            return this.contestCompletionPercentages.map(el => {
                const {
                    contestId,
                    percentualEstagio1,
                    percentualEstagio2,
                    percentualEstagio3,
                    percentualEstagio4,
                    percentualEstagio5,
                } = el;

                return {
                    contestId,
                    percentualStages: [
                        percentualEstagio1,
                        percentualEstagio2,
                        percentualEstagio3,
                        percentualEstagio4,
                        percentualEstagio5,
                    ]
                };
            })
        }
    },
};
</script>
<style scoped>
    .grid-cols-ranking-participants:nth-child(2n+1) {
        background-color: #DBDBDB;
    }
    .progress-bar {
        stroke-dasharray: 320;
        stroke-dashoffset: v-bind(progressCssValue);
        animation: anim 2s linear forwards;
    }

    .grid-cols-list {
        grid-template-columns: 3fr 1fr 2fr 2fr 2fr;
    }
</style>
